/**
 * T-S2-A-3 · 录入模板数据
 * 8 模块各 1-2 个预填模板，供 WizardToolbar "应用模板" 下拉使用。
 * data key 与各 wizard 的 state 变量名 / form 字段名一致。
 */

export interface FormTemplate {
  name: string;
  description?: string;
  data: Record<string, unknown>;
}

export const FORM_TEMPLATES: Record<string, FormTemplate[]> = {
  hotels: [
    {
      name: "黄石山庄",
      description: "自营黄石公园附近山庄",
      data: {
        hotelType: "lodge",
        starTier: 3,
        status: "active",
        locationCity: "Yellowstone",
        supplierType: "self",
      },
    },
    {
      name: "城市标准酒店",
      description: "合约城市商务酒店",
      data: {
        hotelType: "hotel",
        starTier: 3,
        status: "active",
        locationCity: "Salt Lake City",
        supplierType: "self",
      },
    },
  ],

  vehicles: [
    {
      name: "15座面包车",
      description: "Ford Transit 自营标配",
      data: {
        modelCn: "Ford Transit 15座",
        modelYear: 2024,
        seatCap: 15,
        paxCap: 14,
        ownership: "self_owned",
        status: "active",
      },
    },
    {
      name: "25座大巴",
      description: "Mercedes Sprinter 25座",
      data: {
        modelCn: "Mercedes Sprinter 25座",
        modelYear: 2023,
        seatCap: 25,
        paxCap: 24,
        ownership: "self_owned",
        status: "active",
      },
    },
  ],

  drivers: [
    {
      name: "CDL司导",
      description: "持CDL驾照的本地司导",
      data: {
        licenseClass: "CDL",
        hireDate: new Date().toISOString().slice(0, 10),
      },
    },
  ],

  attractions: [
    {
      name: "免费自然景区",
      description: "国家公园免费入场景点",
      data: {
        category: "free_public",
        sourceType: "free_public",
        status: "active",
        baseRateCents: 0,
        dailyBaseQuota: -1,
      },
    },
    {
      name: "收费自营景区",
      description: "自营收费门票景区",
      data: {
        category: "self_managed",
        sourceType: "self_managed",
        status: "active",
        baseRateCents: 2500,
        dailyBaseQuota: 50,
      },
    },
  ],

  suppliers: [
    {
      name: "合约合作伙伴",
      description: "签约地面供应商",
      data: {
        category: "contracted_partner",
        currency: "USD",
      },
    },
    {
      name: "API集成供应商",
      description: "通过API集成的供应商",
      data: {
        category: "api_vendor",
        currency: "USD",
      },
    },
  ],

  channel_partners: [
    {
      name: "旅行社月结",
      description: "传统旅行社信用月结",
      data: {
        category: "traditional_agent",
        settlement_mode: "credit_monthly",
        credit_limit_cents: 100_000,
      },
    },
    {
      name: "企业预付",
      description: "企业客户预付结算",
      data: {
        category: "corporate",
        settlement_mode: "prepaid_immediate",
        credit_limit_cents: 0,
      },
    },
  ],

  products: [
    {
      name: "黄石多日游",
      description: "黄石国家公园多日精华游",
      data: {
        departure_city: "Jackson Hole",
        end_city: "Salt Lake City",
        status: "draft",
        max_pax_per_departure: 20,
        cadence_weeks: 12,
        init_max_pax: 20,
      },
    },
    {
      name: "拉斯维加斯短途",
      description: "大峡谷/布莱斯峡谷一日游",
      data: {
        departure_city: "Las Vegas",
        end_city: "Las Vegas",
        status: "draft",
        max_pax_per_departure: 24,
        cadence_weeks: 8,
        init_max_pax: 24,
      },
    },
  ],

  orders: [
    {
      name: "电话直销",
      description: "电话接单标准配置",
      data: {
        source: "phone_direct",
        paxCount: 2,
      },
    },
    {
      name: "现场接单",
      description: "地接现场接待",
      data: {
        source: "walk_in",
        paxCount: 1,
      },
    },
  ],
};

/** 每个模块"复制上一个"时排除的字段（唯一码 / 系统 ID 类） */
export const COPY_EXCLUDE_FIELDS: Record<string, string[]> = {
  hotels: ["code", "id"],
  vehicles: ["vehicleNumber", "vin", "id"],
  drivers: ["code", "licenseNumber", "id"],
  attractions: ["code", "id"],
  suppliers: ["code", "id"],
  channel_partners: ["id"],
  products: ["code", "id"],
  orders: ["customerName", "customerPhone", "customerEmail", "channelPartnerId", "id"],
};
